import { UxIconEnum, UxIndicator, UxSizeEnum } from "@imaginelearning/mps-ux-component-library";
import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
function Pagination(props) {
    var _a;
    var active = props.active, count = props.count, takeSegmentsState = props.takeSegmentsState, isMasteryCheck = props.isMasteryCheck, goToSegmentCallback = props.goToSegmentCallback, previewMode = props.previewMode;
    var pageSize = 5;
    var currentPage = active || 1;
    var pageCount = count || pageSize;
    var pages = [];
    var _b = useState({
        startPage: currentPage,
        endPage: pageCount,
        showPrevious: false,
        showNext: false,
        showPages: false
    }), visiblePages = _b[0], setVisiblePages = _b[1];
    var handleNavButtonClick = function (num) {
        return setVisiblePages(function (prevState) { return ({
            startPage: prevState.startPage + num * pageSize,
            endPage: prevState.endPage + num * pageSize,
            showPrevious: prevState.startPage + num * pageSize > 1,
            showNext: pageCount > prevState.endPage + num * pageSize,
            showPages: count > 0 && active > 0
        }); });
    };
    var handlePageButtonClick = function (segmentId, okayToSend) {
        if (previewMode || okayToSend) {
            goToSegmentCallback(segmentId);
        }
    };
    var navButton = function (previous) { return (React.createElement(UxIndicator, { size: UxSizeEnum.LARGE, icon: previous ? UxIconEnum.CHEVRON_LEFT : UxIconEnum.CHEVRON_RIGHT, callback: function () { return handleNavButtonClick(previous ? -1 : 1); }, "data-testid": previous ? "previous-button" : "next-button", "aria-label": previous ? "Previous" : "Next", role: "button" })); };
    var _loop_1 = function (pageNo) {
        var furthestProgressPageNo = ((_a = takeSegmentsState.inProgressSegmentIndex) !== null && _a !== void 0 ? _a : 0) + 1;
        var upcomingPage = pageNo > furthestProgressPageNo;
        var disabled = isMasteryCheck || upcomingPage;
        var isStudentActivePage = pageNo === currentPage;
        var className = "completed-item";
        if (pageNo === currentPage)
            className = "active-item";
        else if (upcomingPage)
            className = "inactive-item";
        pages.push(React.createElement(Button, { key: pageNo, "aria-label": pageNo.toString(), disabled: previewMode ? !previewMode : disabled, className: "page-item ".concat(className), "aria-pressed": isStudentActivePage, onClick: function () {
                handlePageButtonClick(takeSegmentsState.segmentIds[pageNo - 1], !disabled && !isStudentActivePage);
            } }, pageNo));
    };
    for (var pageNo = visiblePages.startPage; pageNo <= visiblePages.endPage && pageNo <= pageCount; pageNo += 1) {
        _loop_1(pageNo);
    }
    useEffect(function () {
        var pagePos = (Math.ceil(currentPage / pageSize) - 1) * pageSize;
        var startPage = pagePos + 1;
        var endPage = pagePos + pageSize;
        setVisiblePages({
            startPage: startPage,
            endPage: endPage,
            showPrevious: startPage > pageSize,
            showNext: pageCount > endPage,
            showPages: count > 0 && active > 0
        });
    }, [currentPage, pageCount, active, count]);
    return (React.createElement("div", { className: "pagination flex-row align-items-center pagination-animation ".concat(visiblePages.showPages ? "active" : ""), "data-no-translate": true, "aria-label": "pagination" },
        visiblePages.showPrevious && navButton(true),
        visiblePages.showPages && pages,
        visiblePages.showNext && navButton(false)));
}
export default Pagination;
